import React from 'react'
import ContentLoader from 'react-content-loader'

const RectLoader = ({ style, width, height }) => {
  return (
    <ContentLoader style={style} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x="0" y="0" rx="1" ry="1" width="100%" height="100%" />
    </ContentLoader>
  )
}

export default RectLoader
